import * as React from 'react';
import { ToolbarConfig, MenuConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { TOOLBAR_CLIP } from '@editor/src/img/pageIndex/index';
import { MenuKey } from '@framework/workbench/schema/menu-schema/common';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';
import { TDWActionType, TDWModuleType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { TAILOR_PIC_NORMAL_WITHOUT_ICON } from '@src/framework/workbench/schema/top-menu';

export const config =     {
    id: ActionType.TAILOR_PIC,
    tipMsg: i18n.t('裁剪'),
    title: i18n.t('裁剪'),
    icon: TOOLBAR_CLIP,
    twdConfig: {
        handleFunction: (value) => {
            if (!value) {
                return {};
            }
            let tailorObj;
            if (value === ActionType.TAILOR_PIC_NORMAL) {
                tailorObj = {
                    module: TDWModuleType.PC_TOOLBAR_PIC,
                    action: TDWActionType.PIC_CROP,
                };
            } else {
                tailorObj = {
                    module: TDWModuleType.PC_TOOLBAR_PIC,
                    action: TDWActionType.CROP_MENU,
                    ver5: value,
                };
            }
            return tailorObj;
        },
    },
};

const singleToolTailor: ToolbarConfig = {
    name: config.id,
    icon: <img src={config.icon} alt={''}/>,
    tooltip: config.tipMsg,
    hasArrow: true,
};
const doubleToolTailor: ToolbarConfig = {
    name: wrapIdForBig(config.id),
    icon: <img src={config.icon} alt={''}/>,
    text: config.title,
    tooltip: config.tipMsg,
    hasArrow: true,
    style: {
        width: 'auto',
    },
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    // 单选图片或者图片填充的形状时，浮动工具栏的裁剪按钮显示两个热区
    singleToolTailor,
    doubleToolTailor,
    // 多选包括多个图片或者多个图片填充的形状时，浮动工具栏的裁剪按钮仅一个热区
    {
        ...singleToolTailor,
        name: ActionType.MULTI_TAILOR_PIC,
    },
    {
        ...doubleToolTailor,
        name: wrapIdForBig(ActionType.MULTI_TAILOR_PIC),
    },
];

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        content: config.title,
    },
    {
        name: ActionType.TAILOR_PIC_NORMAL,
        content: config.title,
        icon: <img src={config.icon} alt={''}/>,
    },
    {
        name: TAILOR_PIC_NORMAL_WITHOUT_ICON,
        content: config.title,
    },
    {
        name: MenuKey.TAILOR_PIC_SHAPE_CONTAINER,
        content: i18n.t<string>('裁剪为形状'),
        preventDismiss: true,
    },
];
